// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file shop_config/types/v1/tracking.proto (package shop_config.types.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum shop_config.types.v1.Provider
 */
export const Provider = /*@__PURE__*/ proto3.makeEnum(
  "shop_config.types.v1.Provider",
  [
    {no: 0, name: "PROVIDER_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PROVIDER_GOOGLE", localName: "GOOGLE"},
  ],
);

/**
 * @generated from message shop_config.types.v1.SetTrackerRequest
 */
export const SetTrackerRequest = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.SetTrackerRequest",
  () => [
    { no: 1, name: "tracker", kind: "message", T: Tracker },
  ],
);

/**
 * @generated from message shop_config.types.v1.SetTrackerResponse
 */
export const SetTrackerResponse = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.SetTrackerResponse",
  [],
);

/**
 * @generated from message shop_config.types.v1.GetTrackerRequest
 */
export const GetTrackerRequest = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.GetTrackerRequest",
  () => [
    { no: 2, name: "provider", kind: "enum", T: proto3.getEnumType(Provider) },
  ],
);

/**
 * @generated from message shop_config.types.v1.GetTrackerResponse
 */
export const GetTrackerResponse = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.GetTrackerResponse",
  () => [
    { no: 1, name: "tracker", kind: "message", T: Tracker },
  ],
);

/**
 * @generated from message shop_config.types.v1.ListTrackersRequest
 */
export const ListTrackersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.ListTrackersRequest",
  [],
);

/**
 * @generated from message shop_config.types.v1.ListTrackersResponse
 */
export const ListTrackersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.ListTrackersResponse",
  () => [
    { no: 2, name: "trackers", kind: "message", T: Tracker, repeated: true },
  ],
);

/**
 * @generated from message shop_config.types.v1.Tracker
 */
export const Tracker = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.Tracker",
  () => [
    { no: 1, name: "provider", kind: "enum", T: proto3.getEnumType(Provider) },
    { no: 2, name: "tracking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

